import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const EmployeeVersionSchema = withDefaults({
  type: 'employee-version',
  traits: ['version'],
  fields: [],
});

export default EmployeeVersionSchema;
